module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc31-4461acf056c7f7d5e2cfab0696b0ef81.jpg";